import Icon from '../../components/Icon.vue'

Icon.register({"brands/angular":{"width":415,"height":512,"paths":[{"d":"M169.7 268.1H245.9L207.8 176.5 169.7 268.1zM207.8 32L0 106.4 31.8 382.1 207.8 480 383.8 382.1 415.6 106.4 207.8 32zM338 373.8H289.4L263.2 308.4H152.6L126.4 373.8H77.7L207.8 81.5 338 373.8z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/brands/angular.js